export default __webpack_public_path__ + "static/media/search.710df28e.png";